<template>
  <div>
    <v-container style="padding-top: 80px;">
      <v-row justify="center">
        <v-col lg="6">
          <v-card flat :loading="loading" class="bcg">
            <div v-if="send == false" class="pa-10">
              <form action="#" @submit.prevent="confirm">
                <h2>TRADEinPOOL Password Recovery</h2>
                <span class="public-text">Enter your registered email</span>

                <div class="register mt-6">
                  <v-text-field
                    v-model="email"
                    class="register mt-3"
                    label="Email"
                    background-color="#b6c1cb"
                    color="#4dbac0"
                    light
                    filled
                  ></v-text-field>
                </div>
                <div class="errors">
                  <li v-for="(error, index) in errors" :key="index">{{error}}</li>
                </div>
                <div align="right">
                  <v-btn type="submit" large color="success" class="mt-3">
                    <v-icon>email</v-icon>
                    <span>Send</span>
                  </v-btn>
                </div>
              </form>
            </div>

            <div
              v-else
              class="pa-10 profit"
              style="text-align:center;font-size: 24px;"
            >Email with password reset link has been sent.</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "login",
  components: {},
  data() {
    return {
      created: Math.round(new Date().getTime() / 1000),
      loading: false,
      email: "",
      password: "",
      errors: new Array(),
      send: false
    };
  },
  methods: {
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    confirm() {
      // reset fields
      
      this.errors = [];

      // antispam eliminate by time
      var timeNow = Math.round(new Date().getTime() / 1000);
      if (timeNow < this.created + 2) {
        this.errors.push("Spam bot detected");
      }

      // validate correct email
      if (!this.validateEmail(this.email)) {
        this.errors.push("Email is not correct");
      }

      if (this.errors.length == 0) {
        this.loading = true;
        axios
          .post(
            "https://tradeinpool.com:3001/api/users/recovery/",{user:{email: this.email}}
          )
          .then(response => {
             this.loading = false;
             if(response.data == "Success"){
               this.send = true
             }
          })
          .catch(err => {
            this.errors.push(err)
            this.loading = false;
          });
      } else {
        this.created = Math.round(new Date().getTime() / 1000);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style scoped>
.public-text {
  color: #b6c1ca;
}
.title-small {
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
}
.bcg {
  background-image: url(../assets/img/logo-cropped.svg);
  background-size: contain;
}
</style>